/* eslint-disable max-len */
// Dependencies
import React, {useEffect, useState} from 'react'
import {connect} from 'react-redux'

import Helpers from '../Helpers'

// Images

// Styles
import '@lazarusai/forms-ui-components/dist/index.css'
import stylesTaskQueue from '../styles/TaskQueue.module.css'
import stylesModuleLogList from '../styles/ModuleLogList.module.css'

// Components
import {Table, TableEntry, Button, Icon} from '@lazarusai/forms-ui-components'
import {storePayload} from '../actions/storePayload'


function TaskQueue({
  moduleKey,
  ...props
}) {
  const [tableTasks, setTableTasks] = useState([])

  useEffect(() => {
    setTableTasks(
        Object.keys(Helpers.removeDuplicateTasks(props.modules?.[moduleKey]?.tasks) || {})
            .sort((aKey, bKey) => {
              return (props.modules?.[moduleKey]?.tasks?.[bKey]?.last_update || Number.MIN_SAFE_INTEGER) - (props.modules?.[moduleKey]?.tasks?.[aKey]?.last_update || Number.MIN_SAFE_INTEGER)
            })
            .map((taskKey, tIndex) => {
              const task = props.modules?.[moduleKey]?.tasks?.[taskKey]
              const taskName = task?.name || 'N/a'
              const taskLastUpdate = task?.last_update || null
              const taskDesc = task?.description || task?.prompt || 'N/a'
              const taskStatus = task?.status || 'N/a'
              const taskId = task?.task_id || ''
              return (
                <TableEntry
                  key={`${tIndex}-task`}
                  content={[
                    <div
                      key={`${tIndex}-first-cell`}
                    >
                      <div
                        key={`${tIndex}-task-title`}
                        className={stylesTaskQueue['task-title']}
                      >
                        {taskName}
                      </div>
                      <div
                        key={`${tIndex}-task-id`}
                        className={stylesTaskQueue['claim-id']}
                      >
                        {taskId}
                      </div>
                    </div>,
                    <span
                      key={`${tIndex}-desc`}
                      className={stylesTaskQueue['task-description']}
                    >
                      {taskDesc}
                    </span>,
                    <span
                      key={`${tIndex}-time`}
                      className={stylesTaskQueue['task-status']}
                    >
                      {taskLastUpdate ? `${Helpers.timeStampToDate(taskLastUpdate)} ${Helpers.timeStampToTime(taskLastUpdate)}` : ''}
                    </span>,
                    <span
                      key={`${tIndex}-status`}
                      className={stylesTaskQueue['task-status']}
                    >
                      {taskStatus}
                    </span>,
                    <span
                      key={`${tIndex}-btn`}
                    >
                      <Button
                        className={stylesModuleLogList['mll-modal-button']}
                        text={`View more`}
                        icon={<Icon icon={'arrow-ios-forward-outline'} />}
                        iconPosition={'right'}
                        theme={props.theme}
                        onClick={() => {
                          props.storePayload({
                            taskId: taskKey,
                          })
                        }}
                      />
                    </span>,
                  ]}
                />
              )
            }))
  }, [props.modules, moduleKey])

  return (
    <>
      <div
        className={stylesTaskQueue['task-queue-title']}
      >
        Task Queue
      </div>
      <Table
        showCount={false}
        columnTitles={[
          <span
            key={'header-task'}
          >
            Task
          </span>,
          <span
            key={'header-description'}
          >
            Description
          </span>,
          <span
            key={'header-time'}
          >
            Last Update
          </span>,
          <span
            key={'header-status'}
          >
            Status
          </span>,
          <span
            key={'header-view'}
          >
          </span>,
        ]}
        theme={props.theme}
        className={`${stylesModuleLogList['mll-table']} ${stylesModuleLogList['mll-table-modal']} ${stylesTaskQueue['task-queue-table']}`}
        entries={tableTasks}
      />
    </>
  )
}

const mapStateToProps = (state, ownProps) => ({
  theme: state.userReducer.theme,
  cookies: ownProps.cookies,
  storage: state.firebaseReducer.storage,
  database: state.firebaseReducer.database,
  firestore: state.firebaseReducer.firestore,
  userMessage: state.userReducer.userMessage,
  notificationType: state.userReducer.notificationType,
  notificationIcon: state.userReducer.notificationIcon,
  lang: state.userReducer.lang,
  isSignedIn: state.userReducer.isSignedIn,
  isFirebaseSignedIn: state.userReducer.isFirebaseSignedIn,
  isMFANeeded: state.userReducer.isMFANeeded,
  mfaError: state.userReducer.mfaError,
  user: state.userReducer.user,
  modules: state.userReducer.modules,
})

export default connect(
    mapStateToProps,
    {storePayload},
)(TaskQueue)
